import { render } from "./SampleView.vue?vue&type=template&id=712ab468"
import script from "./SampleView.vue?vue&type=script&lang=js"
export * from "./SampleView.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "712ab468"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('712ab468', script)) {
    api.reload('712ab468', script)
  }
  
  module.hot.accept("./SampleView.vue?vue&type=template&id=712ab468", () => {
    api.rerender('712ab468', render)
  })

}

script.__file = "src/views/misc/SampleView.vue"

export default script